import GameLank from './componant/GameLank';
import styled from 'styled-components';
import GameHeader from './componant/GameHeader';
import Footer from '../components/footer/Footer';

const GameItem = () => {
  return (
    <Container>
      <GameHeader />
      <Content>
        <Inner>
          <Title>우승 물건 목록</Title>
          <Text>투자자가 최종 선택한 부동산 물건들을 한 눈에 확인 가능!</Text>
          <GameLank></GameLank>
        </Inner>
      </Content>
      <Footer />
    </Container>
  );
};

export default GameItem;
const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Inner = styled.div`
  width: 100%;
  padding: 40px 20px;
`;
const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
`;
const Title = styled.div`
  color: #000;

  /* Re_SPOQA/head/bold_24 */
  font-family: 'Spoqa Han Sans Neo';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 34.8px */
  letter-spacing: -0.4px;
  margin-bottom: 12px;
`;

const Text = styled.div`
  color: rgba(0, 12, 30, 0.8);

  /* Re_SPOQA/sub_h/med_18 */
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
`;
